import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../utils/cn';

const labelVariants = cva(
    'flex items-center gap-2 group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
    {
        variants: {
            variant: {
                default: 'text-sm leading-none',
                error: 'text-destructive',
            },
            text: {
                default: '',
                medium: 'font-medium',
            },
            target: {
                default: '',
                checkbox:
                    'relative my-1.5 ml-0 cursor-pointer leading-5 md:ml-2',
                checkboxReversed:
                    'relative top-[2px] my-1.5 ml-0 cursor-pointer leading-5',
            },
            singleLine: {
                true: 'line-clamp-1',
                false: '',
            },
        },
        defaultVariants: {
            variant: 'default',
            text: 'default',
            target: 'default',
            singleLine: false,
        },
    },
);

export const Label = React.forwardRef<
    React.ElementRef<typeof LabelPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
        VariantProps<typeof labelVariants>
>(({ variant, text, target, singleLine, className, ...props }, ref) => (
    <LabelPrimitive.Root
        ref={ref}
        data-slot="label"
        className={cn(
            labelVariants({ variant, text, target, singleLine }),
            className,
        )}
        {...props}
    />
));

Label.displayName = LabelPrimitive.Root.displayName;
